import * as types from '@/store/mutation-types';

const state = {
  userLoading: false,
  orgLoading: false,
  networkModal: false,
};

const getters = {
  userLoading(state) {
    return state.userLoading;
  },
  orgLoading(state) {
    return state.orgLoading;
  },
  networkModal(state) {
    return state.networkModal;
  },
};

const mutations = {
  [types.SET_USER_LOADING](state, { value }) {
    state.userLoading = value;
  },
  [types.SET_ORG_LOADING](state, { value }) {
    state.orgLoading = value;
  },
  [types.SET_NETWORK_MODAL](state, value) {
    state.networkModal = value;
  },
};

const actions = {
  setUserLoading({ commit }, params) {
    commit(types.SET_USER_LOADING, params);
  },
  setorgLoading({ commit }, params) {
    commit(types.SET_ORG_LOADING, params);
  },
  setNetworkModal({ commit }, value) {
    commit(types.SET_NETWORK_MODAL, value);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
